import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FaHome,
  FaUsers,
  FaShieldAlt,
  FaStream,
  FaPlug,
  FaCog,
  FaIdBadge,
  FaDigitalTachograph,
  FaBars,
  FaFingerprint,
} from "react-icons/fa";
import { X } from "lucide-react";
import "./Sidebar.css";

const menuItems = [
  { path: "/overview", label: "Overview", icon: <FaHome /> },
  { path: "/identities", label: "Identities", icon: <FaUsers /> },
  {
    path: "/auth-activity",
    label: "Authentication Activity",
    icon: <FaShieldAlt />,
  },
  // { path: '/auth-events', label: 'Authentication Events', icon: <FaStream /> },
  { path: "/policies", label: "Policies", icon: <FaCog /> },
  { path: "/tenant-info", label: "Tenant Info", icon: <FaIdBadge /> },
  { path: "/visuals", label: "Visuals", icon: <FaDigitalTachograph /> },
  { path: "/adapid-mfa", label: "AdapID MFA", icon: <FaFingerprint /> },
  { path: "/integrations", label: "Integrations", icon: <FaPlug /> },
];

const Sidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();

  const isExpanded = !collapsed;

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const getNavClass = (item) =>
    location.pathname === item.path ? "nav-link active" : "nav-link";

  return (
    <aside className={`sidebar ${collapsed ? "sidebar-collapsed" : ""}`}>
      <div className="sidebar-top-section">
        {isExpanded ? (
          <>
            {/* <div className="sidebar-heading">NAVIGATION MENU</div> */}

            <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
              <X size={16} />
            </button>
          </>
        ) : (
          <button
            className="sidebar-toggle-btn sidebar-hamburger"
            onClick={toggleSidebar}
          >
            <FaBars size={16} />
          </button>
        )}
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li key={item.path} className="nav-item">
              <NavLink to={item.path} className={getNavClass(item)}>
                <span className="nav-icon">{item.icon}</span>

                {isExpanded && <span className="nav-label">{item.label}</span>}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {isExpanded && (
        <div className="sidebar-footer">
          <div className="footer-text">Continuous Identity Risk Management</div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
